// extracted by mini-css-extract-plugin
export default {"suggestion":"eTLJ9","labelAddressText":"MBjkg"};